export function isFunction(fn: any): boolean {
  return typeof fn === 'function';
}
